export default __webpack_public_path__ + "static/media/6.d83fc5f2.png";